import search from '../md-search';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from '../md-search/asyncData';
// import { LAYOUTOPTIONS_UPDATE_MUTATION } from '../md-search/_store/config';
export default {
    mixins: [search],
    asyncData: mapAsyncData(asyncData),
    // asyncData: mapAsyncData(function(context){
    //     context.commit(LAYOUTOPTIONS_UPDATE_MUTATION, ['normal']);
    //     return asyncData.call(this, context);
    // }),
    data: function() {
        return {
            showSearchBar: true,
            keywordsPlaceholder: '',
            showSchool: false,
            mapSearchText: null,
            mapDrawTip: null
        };
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        }
    }
};
